import { dangerousGettext, gettext } from '@eventbrite/i18n';
import {
    getTld,
    SupportedTLD,
} from '../../components/pricingAndPackagingUtils';

type TldArticleMapType = {
    [key in SupportedTLD]: string;
};

const TLD_TO_COST_ARTICLE_LINK: TldArticleMapType = {
    [SupportedTLD.Canada]:
        'https://www.eventbrite.ca/help/en-ca/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
    [SupportedTLD.UnitedKingdom]:
        'https://www.eventbrite.co.uk/help/en-gb/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
    [SupportedTLD.Ireland]:
        'https://www.eventbrite.ie/help/en-ie/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
    [SupportedTLD.Australia]:
        'https://www.eventbrite.com.au/help/en-au/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
    [SupportedTLD.NewZealand]:
        'https://www.eventbrite.co.nz/help/en-nz/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
    [SupportedTLD.UnitedStates]:
        'https://www.eventbrite.com/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
};

const TLD_TO_FUNDRAISER_ARTICLE_LINK: TldArticleMapType = {
    [SupportedTLD.Canada]:
        'https://www.eventbrite.ca/help/en-ca/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
    [SupportedTLD.UnitedKingdom]:
        'https://www.eventbrite.co.uk/help/en-gb/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
    [SupportedTLD.Ireland]:
        'https://www.eventbrite.ie/help/en-ie/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
    [SupportedTLD.Australia]:
        'https://www.eventbrite.com.au/help/en-au/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
    [SupportedTLD.NewZealand]:
        'https://www.eventbrite.co.nz/help/en-nz/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
    [SupportedTLD.UnitedStates]:
        'https://www.eventbrite.com/help/en-us/articles/460357/how-to-fundraise-and-collect-donations-with-eventbrite/',
};

export const QUESTION_ANSWER = [
    {
        question: gettext('What’s included when I use Eventbrite?'),
        answer: [
            {
                heading: '',
                linkText: dangerousGettext(
                    "When you host with Eventbrite, your event is featured on the world's largest and most trusted events \
                    marketplace, where millions of global ticket buyers discover things to do. <br/><br/>You’ll have access to our complete toolkit, including integrated event ticketing, AI-powered event setup, \
                    secure payment processing, and powerful social media and email marketing tools—all designed to help \
                    you create a stand-out event. Learn more about our features <a href='/organizer/overview' target='__blank'>here.</a>",
                ),
            },
        ],
    },
    {
        question: gettext('Is it free to use Eventbrite?'),
        answer: [
            {
                heading: '',
                linkText: dangerousGettext(
                    "Yes, publishing your event on Eventbrite is free! Your attendees pay Ticketing Fees including a service fee \
                    and payment processing fee where applicable, unless you choose to cover them. If your event is free, no \
                    Ticketing Fees apply. Learn more about our Ticketing Fees  <a href='%(costArticleLink)s' target='__blank'>here.</a> <br/><br/>There is an additional cost associated with running Eventbrite Ads or launching Instagram and Facebook \
                    ads through Eventbrite.",
                    {
                        costArticleLink:
                            TLD_TO_COST_ARTICLE_LINK[getTld() as SupportedTLD],
                    },
                ),
            },
        ],
    },
    {
        question: gettext('Do you offer special pricing for nonprofits?'),
        answer: [
            {
                heading: '',
                linkText: dangerousGettext(
                    "Yes, we offer discounted Ticketing Fees on <a href='%(fundraiserArticleLink)s' target='__blank'>donation tickets </a>\
                    , so more funds go directly to your cause. Additionally, qualifying nonprofits get <a href='/l/email-marketing/' target='__blank'> 50% off our Pro plans </a> \
                    so you can save on sending more marketing emails with Eventbrite. <br/><br/> We’re committed to supporting nonprofits with tailored features to help you and your community thrive. \
                    Learn more <a href='/l/npo/' target='__blank'> here </a> and discover how Eventbrite can empower your mission.",
                    {
                        fundraiserArticleLink:
                            TLD_TO_FUNDRAISER_ARTICLE_LINK[
                                getTld() as SupportedTLD
                            ],
                    },
                ),
            },
        ],
    },
    {
        question: gettext('What if my event is free?'),
        answer: [
            {
                heading: '',
                text: gettext(
                    'If your event is free, there are no fees to publish on Eventbrite and no Ticketing Fees for your attendees.',
                ),
            },
        ],
    },
    {
        question: gettext('What support do I get with Eventbrite?'),
        answer: [
            {
                heading: gettext(''),
                text: gettext(
                    'All Eventbrite organizers have access to our comprehensive Help Center and educational resources to \
                    help make your event seamless.',
                ),
            },
            {
                heading: gettext(''),
                text: gettext(
                    'If you’re hosting a free event, you’ll have access to our email support, and you can subscribe to Pro for \
                    24/7 chat support. For organizers with paid ticket events, we offer both email and 24/7 chat support. ',
                ),
            },
            {
                heading: gettext(''),
                linkText: dangerousGettext(
                    "Finally, if you’re hosting large events, you can <a href='/l/contact-eventbrite-sales/' target='__blank'> contact our sales team </a> for dedicated phone support and strategic advising to help you maximize our platform.",
                ),
            },
        ],
    },

    {
        question: gettext('What is Eventbrite Pro?'),
        answer: [
            {
                heading: gettext(''),
                linkText: dangerousGettext(
                    "Eventbrite Pro is a subscription add-on that offers extra daily email sends with our powerful marketing tool.\
                    <a href='/l/email-marketing/' target='__blank'>Learn more here. </a>",
                ),
            },
        ],
    },
];
